import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useState } from 'react';
import Button from 'reactstrap/es/Button';
import classNames from 'classnames';
import DatePicker from 'react-datepicker';
export function ButtonDatePicker({ onChange, isActive }) {
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState(null);
    function onInternalChange(values) {
        const [start, end] = values;
        setStartDate(start);
        setEndDate(end);
        if (start && end)
            return onChange(values);
    }
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (_jsx(Button, Object.assign({ onClick: onClick, ref: ref, color: isActive ? 'dark' : 'secondary', className: classNames({ active: isActive }) }, { children: isActive ? value : 'Период' }))));
    return (_jsx(DatePicker, { customInput: _jsx(ExampleCustomInput, {}), selected: startDate, onChange: onInternalChange, startDate: startDate, endDate: endDate, selectsRange: true }));
}
